export type Regional = {
  idDistribuidor: string;
  nomeCompletoDistribuidor: string;
  regiaoUL: string;
  formatoUL: string;
  estado: string;
};

export type RegionalChange = {
  idDistribuidor: string;
  nomeDistribuidor: string;
  campo: 'Regional UL' | 'Formato UL';
  valorAnterior: string;
  valorNovo: string;
};

export type HistoryEntry = {
  id: string;
  date: string;
  user: string;
  changes: RegionalChange[];
};

export type RegionalBatchItem = {
  id_distribuidor: string;
  regional_ul?: string;
  formato_ul?: string;
};

export const REGIAO_UL_OPTIONS = [
  'Sul',
  'S\u00e3o Paulo',
  'Centro-Norte',
  'Leste',
  'Nordeste',
  'N\u00e3o definido',
] as const;

export const REGIAO_UL_DROPDOWN_OPTIONS = [
  'Sul',
  'S\u00e3o Paulo',
  'Centro-Norte',
  'Leste',
  'Nordeste',
] as const;

export const FORMATO_UL_OPTIONS = [
  'AE',
  'AT',
  'AT FARMA',
  'E-UB',
  'Cash Carry Regular',
  'NC',
] as const;

export type ImportRow = {
  idDistribuidor: string;
  nomeDistribuidor: string;
  regiaoUL: string;
  formatoUL: string;
  valid: boolean;
  reason?: string;
  changeType?: 'changed' | 'unchanged';
  currentRegiaoUL?: string;
  currentFormatoUL?: string;
};
